import React, { useState, useEffect } from "react"

import { Section, Block, Note } from "../Sandbox"
import Button from "./Button"
import Link from "./Link"
import { Icon } from "./Icon"
import Paginator from "./Paginator"
import { EMBED_INFO_CONTEXT_MAGAZIN, EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE } from "@Quiz/QuizEmbedInfoContext"
import EmbedHostAndColorModeSwitcher from "../Sandbox/EmbedHostAndColorModeSwitcher"

const ICONS = [
  { name: "SZ", icons: EMBED_INFO_CONTEXT_SZ_ON_SEPARATE_PAGE.resultIcons },
  { name: "Magazin", icons: EMBED_INFO_CONTEXT_MAGAZIN.resultIcons },
]

const Icons: React.FC = () => {
  const [ keyForRandomIcons, setKeyForRandomIcons ] = useState(0)
  useEffect(() => {
    const interval = window.setInterval(
      () => setKeyForRandomIcons((prev) => prev + 1),
      400
    )

    return () => { // cleanup
      window.clearInterval(interval)
    }
  })

  return (
    <Section title="Icons">
      {ICONS.map((section) => {
        return <div key={section.name}>
          <Note>{`${section.name} Happy`}</Note>
          <div>
            {section.icons.positive.map((i) => {
              return <Icon key={i} iconIds={[i]} />
            })}
          </div>
          <div>
            <Note>{"...random"}</Note>
            <Icon iconIds={section.icons.positive} key={keyForRandomIcons} />
          </div>
          <Note>{`${section.name} Happy (respectful)`}</Note>
          <div>
            {section.icons.positiveRespectful
              ? <>
                  <div>
                    {section.icons.positiveRespectful.map((i) => {
                      return <Icon key={i} iconIds={[i]} />
                    })}
                  </div>
                  <div>
                    <Note>{"...random"}</Note>
                    <Icon iconIds={section.icons.positiveRespectful} key={keyForRandomIcons} />
                  </div>
                </>
              : <strong>-</strong>}
          </div>
          <Note>{`${section.name} Sad`}</Note>
          <div>
            {section.icons.negative.map((i) => {
              return <Icon key={i} iconIds={[i]} />
            })}
          </div>
          <div>
            <Note>{"...random"}</Note>
            <Icon iconIds={section.icons.negative} key={keyForRandomIcons} />
          </div>
          <Note>{`${section.name} Check`}</Note>
          <div>
            {section.icons.check.map((i) => {
              return <Icon key={i} iconIds={[i]} />
            })}
          </div>
          <Note>{`${section.name} Question`}</Note>
          <div>
            {section.icons.question.map((i) => {
              return <Icon key={i} iconIds={[i]} />
            })}
          </div>
        </div>
      })}      
    </Section>
  )
}

const PaginatorSandbox: React.FC = () => {
  const toPage = (p: number) => { console.log(`To page ${p}`) }

  return <Section title="Paginator">
    <Note><strong>1</strong>, 2, 3, 4, 5</Note>
    <Block>
      <Paginator info={{current: 1, total: 10}} toPage={toPage} />
    </Block>
    <Note>1, 2, <strong>3</strong>, 4, 5</Note>
    <Block>
      <Paginator info={{current: 3, total: 10}} toPage={toPage} />
    </Block>
    <Note>1, 2, <strong>3</strong>, 4</Note>
    <Block>
      <Paginator info={{current: 3, total: 4}} toPage={toPage} />
    </Block>
    <Note>4, 5, <strong>6</strong>, 7, 8</Note>
    <Block>
      <Paginator info={{current: 6, total: 10}} toPage={toPage} />
    </Block>
    <Note>6, 7, 8, 9, <strong>10</strong></Note>
    <Block>
      <Paginator info={{current: 10, total: 10}} toPage={toPage} />
    </Block>
  </Section>
}

const GenericUiSandbox: React.FC = () => {
  return <EmbedHostAndColorModeSwitcher>
    <Section title="Button">
      <Note>Normal / Long text (mobile layout)</Note>
      <Block>
        <div className="neo__quiz--mobile sandbox__FlexWithMargin">
          <Button onClick={() => alert("click")}>With onClick</Button>
          <Button onClick={() => alert("click")}>This is a button with long text, but there will be no linebreak.</Button>
          <Button href={"#button-href"}>With href</Button>
          <Button>Disabled</Button>
          <Button variant="secondary" onClick={() => alert("click")}>With onClick</Button>
          <Button variant="secondary" onClick={() => alert("click")}>This is a button with long text, but there will be no linebreak.</Button>
          <Button variant="secondary" href={"#button-href"}>With href</Button>
          <Button variant="secondary">Disabled</Button>
        </div>
      </Block>
      <Note>Normal / Long text (desktop layout)</Note>
      <Block>
        <div className="neo__quiz--desktop sandbox__FlexWithMargin">
          <Button onClick={() => alert("click")}>With onClick</Button>
          <Button onClick={() => alert("click")}>This is a button with long text, it is multiline.</Button>
          <Button href={"#button-href"}>With href</Button>
          <Button>Disabled</Button>
          <Button variant="secondary" onClick={() => alert("click")}>With onClick</Button>
          <Button variant="secondary" onClick={() => alert("click")}>This is a button with long text, it is multiline.</Button>
          <Button variant="secondary" href={"#button-href"}>With href</Button>
          <Button variant="secondary">Disabled</Button>
        </div>
      </Block>
    </Section>
    <Section title="Link">
      <Note>(No difference between mobile/desktop)</Note>
      <Block>
        <div style={{display: "flex", justifyContent: "space-evenly", alignItems: "center"}}>
          <Link onClick={() => alert("click")}>With onClick</Link>
          <Link href={"#link-href"}>With href</Link>
        </div>
      </Block>
    </Section>
    <Icons />
    <PaginatorSandbox />
  </EmbedHostAndColorModeSwitcher>
}

export default GenericUiSandbox
